<button class="btn btn-secondary" (click)="publishAllCommentsClicked()" [disabled]="isDisabled()">
    <i class="fa-solid fa-save mr-1"></i>
    Publish All Comments
</button>
